import React from 'react';

import Icon from '../Icon/Icon';

const ContactUsIcon = (props) => {
    return (
        <Icon width='32' height='32' fill='none' {...props}>
            <path
                d='M9.22972 13.1353H7.30352C5.47904 13.1353 4 14.5646 4 16.3277V19.2401C4 21.0032 5.47904 22.4325 7.30352 22.4325H8.38037C8.84945 22.4325 9.22972 22.0651 9.22972 21.6117V13.1353Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.6215 7.32432C12.0913 7.32432 9.22959 10.1861 9.22959 13.7162V15.1777C9.22959 15.8195 8.70928 16.3399 8.06743 16.3399C7.42559 16.3399 6.90527 15.8195 6.90527 15.1777V13.7162C6.90527 8.90238 10.8076 5 15.6215 5H16.4931C21.3069 5 25.2093 8.90238 25.2093 13.7162V15.4594C25.2093 16.1013 24.689 16.6216 24.0471 16.6216C23.4053 16.6216 22.885 16.1013 22.885 15.4594V13.7162C22.885 10.1861 20.0232 7.32432 16.4931 7.32432H15.6215Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M25.2784 19.5469V21.0138C25.2784 23.4917 23.2697 25.5003 20.7919 25.5003H16.9866V24.4096H20.7919C22.6673 24.4096 24.1876 22.8892 24.1876 21.0138V19.5469H25.2784Z'
                fill='#393E44'
            />
            <rect x='14.1689' y='23.5947' width='4.64864' height='2.9054' rx='1.4527' fill='#393E44' />
            <path
                d='M22.8853 13.1353H24.8115C26.6359 13.1353 28.115 14.5646 28.115 16.3277V19.2401C28.115 21.0032 26.6359 22.4325 24.8115 22.4325H23.7346C23.2655 22.4325 22.8853 22.0651 22.8853 21.6117V13.1353Z'
                fill='#393E44'
            />
            <path
                d='M24.0474 15.4595C24.0474 15.1386 24.3075 14.8784 24.6284 14.8784H25.2095C26.1723 14.8784 26.9528 15.6589 26.9528 16.6217V18.946C26.9528 19.9087 26.1723 20.6892 25.2095 20.6892H24.6284C24.3075 20.6892 24.0474 20.4291 24.0474 20.1081V15.4595Z'
                fill='#00D1D2'
            />
            <path
                d='M8.06751 15.4595C8.06751 15.1386 7.80735 14.8784 7.48643 14.8784H6.90535C5.94258 14.8784 5.16211 15.6589 5.16211 16.6217V18.946C5.16211 19.9087 5.94258 20.6892 6.90535 20.6892H7.48643C7.80735 20.6892 8.06751 20.4291 8.06751 20.1081V15.4595Z'
                fill='#00D1D2'
            />
        </Icon>
    );
};

export default ContactUsIcon;
